import NavigateBeforeSharpIcon from "@mui/icons-material/NavigateBeforeSharp";
import NavigateNextSharpIcon from "@mui/icons-material/NavigateNextSharp";
import { Button, IconButton, Stack } from "@mui/material";
import dayjs from "dayjs";
import { useContext } from "react";
import { useController } from "react-hook-form";
import * as yup from "yup";
import { Form, FormContext } from "components/shared/Form";
import RHFDatePicker from "components/ui/atoms/formFields/RHFDatePicker";

const validationSchema = yup.object({
  date__date: yup
    .date()
    .transform((value, originalValue) => {
      // Hack: use the original value instead of value to prevent yup.date to change the timezone
      return new Date(originalValue);
    })
    .nullable(),
});

const getInitialValues = (object) => {
  return {
    date__date: object?.date__date || null,
  };
};

const EventFields = ({}) => {
  const {
    form: { control },
  } = useContext(FormContext);
  const { field } = useController({
    control: control,
    name: "date__date",
  });

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <IconButton
        sx={{ p: 0 }}
        onClick={(event) => {
          field.onChange(
            dayjs(field.value).add(-1, "day").format("YYYY-MM-DD"),
          );
        }}
      >
        <NavigateBeforeSharpIcon />
      </IconButton>
      <Button
        variant="text"
        onClick={(event) => {
          field.onChange(dayjs().format("YYYY-MM-DD"));
        }}
      >
        Today
      </Button>
      <IconButton
        sx={{ p: 0 }}
        onClick={(event) => {
          field.onChange(dayjs(field.value).add(1, "day").format("YYYY-MM-DD"));
        }}
      >
        <NavigateNextSharpIcon />
      </IconButton>
      <RHFDatePicker
        type="number"
        name="date__date"
        label=""
        placeholder="Date"
        hideErrorText
        sx={{ maxWidth: "110px" }}
      />
    </Stack>
  );
};

const EventForm = (props) => {
  return (
    <Form
      validationSchema={validationSchema}
      prepareInitialValues={getInitialValues}
      {...props}
    >
      <EventFields />
    </Form>
  );
};

export default EventForm;
